module.exports = __webpack_public_path__ + "img/gb9128_1_f.prt.4ad591bf.jpg";